import React from 'react';
import { useIntl } from 'umi';
import StarNum from './StarNum';
import { getChartsShowCount, getPercentageInfo } from '../../utils';
import { Bubble } from 'tea-component';
import './index.scss';

export default function StarBubble({
  detail,
  mentions,
  children,
  className,
  isLifetime,
  detailPage
}: any) {
  return (
    <Bubble
      className="dbo-scorebubble-wrap"
      placement="right"
      closeOnScroll
      content={
        <StarBubbleBlock
          isLifetime={isLifetime}
          detail={detail}
          mentions={mentions}
          detailPage={detailPage}
        />
      }
      dark
    >
      <div className={`${className}`}>{children}</div>
    </Bubble>
  );
}

function StarBubbleBlock({ detail, mentions, isLifetime, detailPage }: any) {
  const { formatMessage } = useIntl();
  return (
    <>
      <div className="dbo-scorebubble">
        <div className="dbo-scorebubble-col dbo-scorebubble-col--rate">
          <span className="dbo-scorebubble-tit">
            {formatMessage({ id: 'Rating' })}
          </span>
          <div className="dbo-scorebubble-content">
            <div className="dbo-scorebubble-markbox">
              {[5, 4, 3, 2, 1].map((key) => (
                <span
                  key={key}
                  className={`dbo-scorebubble-mark star${key}`}
                ></span>
              ))}
            </div>
            <StarNum />
          </div>
        </div>
        <div className="dbo-scorebubble-col">
          <span className="dbo-scorebubble-tit">
            {formatMessage({ id: isLifetime ? 'Ratings-2' : 'Reviews-2' })}
          </span>
          <div className="dbo-scorebubble-content">
            {[5, 4, 3, 2, 1].map((key) => (
              <span key={key}>{getChartsShowCount(detail[key], 2, '-')}</span>
            ))}
          </div>
        </div>
        <div className="dbo-scorebubble-col">
          <span className="dbo-scorebubble-tit">
            {formatMessage({ id: 'Share-1' })}
          </span>
          <div className="dbo-scorebubble-content">
            {[5, 4, 3, 2, 1].map((key) => (
              <span key={key}>{getPercentageInfo(detail[key], mentions, 2)}</span>
            ))}
          </div>
        </div>
      </div>
      {
        detailPage && (
          <span>
            {formatMessage({ id: 'Click the chart to view related reviews' })}
          </span>
        )
      }
    </>
  );
}
